import { render, staticRenderFns } from "./AxeEditPicture.vue?vue&type=template&id=07064915&"
import script from "./AxeEditPicture.vue?vue&type=script&lang=js&"
export * from "./AxeEditPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports